import * as focusTrap from 'focus-trap';

class MobileNavigation {
  constructor() {
    this.nav = null;
    this.burger = document.querySelector('.js-navbar-burger');

    if (this.burger) {
      this.nav = document.querySelector('#' + this.burger.dataset.target);
    }

    this.offcanvasClose = document.querySelector('.js-offcanvas-close');
  }
  init() {
    if (this.burger && this.nav) {
      this.bindEvents();
    }
  }
  bindEvents() {
   
    this.trap = focusTrap.createFocusTrap(this.nav)

    this.burger.addEventListener('click', () => {
     this.openOffcanvas()
    });

    this.offcanvasClose.addEventListener('click', () => {
      this.closeOffcanvas()
    });

    this.offcanvasClose.addEventListener('keydown', (e) => {
        if (e.code === 'Space' || e.code === 'Enter') {
            e.preventDefault()
            this.closeOffcanvas()
        }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeOffcanvas()
      }
    });

  }

  openOffcanvas() {
    this.nav.removeAttribute('inert')
    this.nav.classList.add('is-active');
    this.trap.activate();
    this.burger.setAttribute('aria-expanded', 'true');
  }

  closeOffcanvas() {
    this.nav.classList.remove('is-active');
    this.trap.deactivate({
      onPostDeactivate: () => this.nav.setAttribute('inert','')
  });
  this.burger.setAttribute('aria-expanded', 'false');

  }
}

export default new MobileNavigation();
